// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeDotsMenu_wrapper__2LALm","threeDots":"ThreeDotsMenu_threeDots__3OOb-","actionsList":"ThreeDotsMenu_actionsList__3aL8C","action":"ThreeDotsMenu_action__3yB7j"};